export default {
  serverNotAvailable () {
    $('#btn-noti-error').click()
  }
}



// WEBPACK FOOTER //
// ./src/services/alter-service.js